import { Component, OnInit } from '@angular/core';
import { TranslateService } from "../../../common/variables/translate-service";

@Component({
  selector: 'sen-app-set-margin',
  templateUrl: './set-margin.component.html',
  styleUrls: ['./set-margin.component.scss']
})
export class SetMarginComponent implements OnInit {

  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
  }

}
